export const DEFAULT_CURRENCY = 'EUR';

export const SUPPORTED_CURRENCIES = [
  { code: 'EUR', label: 'Euro', exampleLocale: 'fr-FR' },
  { code: 'USD', label: 'Dollar américain', exampleLocale: 'en-US' },
  { code: 'GBP', label: 'Livre sterling', exampleLocale: 'en-GB' },
  { code: 'CHF', label: 'Franc suisse', exampleLocale: 'fr-CH' },
  { code: 'CAD', label: 'Dollar canadien', exampleLocale: 'fr-CA' },
  { code: 'JPY', label: 'Yen japonais', exampleLocale: 'ja-JP' },
  { code: 'MAD', label: 'Dirham marocain', exampleLocale: 'fr-MA' },
  { code: 'XOF', label: 'Franc CFA', exampleLocale: 'fr-SN' },
];

export function normalizeCurrency(currency?: string): string {
  const normalized = currency?.trim().toUpperCase();
  if (!normalized) return DEFAULT_CURRENCY;
  return SUPPORTED_CURRENCIES.some((item) => item.code === normalized) ? normalized : DEFAULT_CURRENCY;
}

export function formatMoney(value: number, currency = DEFAULT_CURRENCY, maximumFractionDigits?: number) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: normalizeCurrency(currency),
    maximumFractionDigits,
  }).format(value);
}

export function formatCompactMoney(value: number, currency = DEFAULT_CURRENCY) {
  const absoluteValue = Math.abs(value);
  const symbol = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: normalizeCurrency(currency),
    maximumFractionDigits: 0,
  })
    .formatToParts(0)
    .find((part) => part.type === 'currency')?.value;

  if (absoluteValue >= 1000) {
    return `${(absoluteValue / 1000).toFixed(1).replace('.', ',')}k${symbol ? ` ${symbol}` : ''}`;
  }

  return `${absoluteValue.toFixed(0)}${symbol ? ` ${symbol}` : ''}`;
}
